import ContactBlock from './contact-block';

export default ContactBlock;